module.exports = __webpack_public_path__ + "static/media/t2.87815331.png";